import React from "react";
import "./Cards.css";
import CardItem from "../Service/CardItems";
import WebIcon from '@material-ui/icons/Web';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import SettingsInputHdmiOutlinedIcon from '@mui/icons-material/SettingsInputHdmiOutlined';
import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';

// import CameraAltIcon from '@material-ui/icons/CameraAlt';
// import AcUnitIcon from '@material-ui/icons/AcUnit';


function Cards() {
  return (
    <div className="cards">
      <h6 style={{ textAlign: 'center', color: "#1E978C", marginTop: '15px' }}> AI POWERED SOLUTIONS</h6>
      <h1>What We Offer </h1>
      <p style={{ paddingLeft: 20, paddingRight: 20, textAlign: 'center' }}>Smart, scalable, AI-powered solutions to support every stage of your business growth.</p>

      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">

             <CardItem
              icon={<WebIcon />}
              text="AI Software Development Services"
              para="We build smarter systems with powerful AI at the core.From automation to enhancing user experience, AI drives every solution.At Aizonix Solutions, our AI-powered apps, predictive models, Chatbot and computer vision turns complexity into growth."
              />
            <CardItem
              icon={<WebIcon />}
              text="Web Development"
              para="Our web services range from simple websites to complex CRM and ERP solutions using React JS, Next.js, and the Django framework."
            />

          </ul>
          <ul className="cards__items">
            <CardItem
              icon={<PhoneIphoneIcon />}
              text="Mobile Development"
              para="We have the expertise to develop fully-fledged, stable, and scalable mobile applications for both Android and iOS platforms."
            />
            <CardItem
              icon={<SettingsInputHdmiOutlinedIcon />}
              text="Plugin Development"
              para="Get custom WordPress plugins tailored to your needs—AI-enabled and built on the world's leading CMS platform."
              path="/Floodinfo"
            />
            <CardItem
              icon={<GraphicEqOutlinedIcon />}
              text="Design & UX Excellence"
              para="User‑friendly, AI‑enhanced interfaces turn complex apps into easy user experiences, while intuitive UI, striking logos, and flyers amplify your brand with smart, impactful design."
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;